<template>
  <div>
    <a v-if="hasId" :id="slugifiedId" aria-label="Section anchor link" aria-hidden="true"></a>
  </div>
</template>

<script>
import { generateRelativeLinkByLocale } from 'JS/global.js';

export default {
  props: {
    id: { type: String, default: '' },
    blockId: { type: String, default: '' },
  },
  data() {
    return {
      slugifiedId: '',
      hasId: true,
    };
  },
  mounted() {
    // If section block has a title associated with it, slugify it and create a relative anchor link to be used by the Header sidebar quicklinks. Otherwise don't assign an ID, and don't render the relative anchor link.
    if(!this.id){
      this.hasId = false
    }
    this.slugifiedId = generateRelativeLinkByLocale(this.$i18n?.locale, this.id, this.blockId);
  },
};
</script>
